export default class AlEntityChangelogComponentController {

    constructor($injector, $scope) {
        this.injector = $injector;
        this.scope = $scope;
        this.translate = this.injector.get('$translate');

        this.initiated = false;
        this.showStore = false;
        this.allowedEntities = [
            'contact',
            'rsvp',
            'voucher'
        ];

        this._initWatchers();
    }

    $postLink() {
        this._initStore();
        this.initiated = true;
    }

    _initStore() {
        if (!this.initiated || !this._isEntityValid()) {
            return;
        }
        this.showStore = false;

        if (this._isPrimaryValid()) {
            this.store = this.injector.get('ActionLogEntries').reset({
                listview: `ChangelogEntries${_.upperFirst(_.camelCase(this.entity))}${this.entityId}ListView`,
                persist: false
            });
        } else {
            this.store = this.injector.get('ActionLogEntries').reset({
                listview: `ChangelogEntries${_.upperFirst(_.camelCase(this.entity))}ListView`,
                persist: true
            });
        }

        let slug = `changelog/${this.entity}`;

        if (this.slugOverride) {
            slug = _.clone(this.slugOverride);
        }

        if (this._isPrimaryValid()) {
            slug += `/${this.entityId}`;
        }

        this.store.commit('setSlug', slug);
        this.store.commit('setTitle', this.translate.instant(`action-log.components.entity-change-log.titles.${this.entity}`));

        this.showStore = true;
    }

    _isEntityValid() {
        return !!this.entity && _.isString(this.entity) && this.allowedEntities.indexOf(this.entity) !== -1;
    }

    _isPrimaryValid() {
        return !!this.entityId && _.isInteger(this.entityId);
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.entity;
        }, () => {
            this._initStore();
        });

        this.scope.$watch(() => {
            return this.entityId;
        }, () => {
            this._initStore();
        });

        this.scope.$watch(() => {
            return this.slugOverride;
        }, () => {
            this._initStore();
        });
    }
}

AlEntityChangelogComponentController.$inject = [
    '$injector',
    '$scope'
];



// WEBPACK FOOTER //
// ./src/app/modules/action_log/components/entity-change-log/controller.js